$(document).ready(function () {
  
    $('button[name="checkout"]').on('click', function (e) {
    var code = $('#cart_coupon_code').val();
    if (code && $.trim(code) !== '') {
      e.preventDefault();
      window.location.href =
        '/discount/' + encodeURIComponent($.trim(code)) + '?redirect=/checkout';
    }
  });

});

